import React from 'react';
import { Theme } from '@teko/ui';
import Head from 'next/head';
import { SiteMeta, TenantEnv } from 'types';

function MetaHead({
  theme,
  config,
  meta,
}: {
  theme: Theme;
  config: TenantEnv;
  meta: SiteMeta;
}): React.ReactElement {
  const { tenant, logoUrl, schemaWebsite } = config;

  const getIconUrl = (size: number) => `${logoUrl}=w${size}`;

  return (
    <Head>
      <title>{meta?.title}</title>
      <link
        rel="shortcut icon"
        href={logoUrl ? getIconUrl(16) : `/${tenant}/favicon.ico?`}
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={logoUrl ? getIconUrl(180) : `/${tenant}/apple-touch-icon.png?`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={logoUrl ? getIconUrl(32) : `/${tenant}/favicon-32x32.png?`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={logoUrl ? getIconUrl(16) : `/${tenant}/favicon-16x16.png?`}
      />
      <link rel="manifest" href={`/${tenant}/site.webmanifest`} />
      <meta
        name="msapplication-TileColor"
        content={theme.brand.primary || '#ffffff'}
      />
      <meta name="theme-color" content={theme.brand.primary || '#ffffff'} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1.0, shrink-to-fit=no"
      />
      {schemaWebsite && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemaWebsite),
          }}
        />
      )}
    </Head>
  );
}

export default MetaHead;
